export enum ActionType {
    JumpTo = 'JumpTo',
    SendEmailAsync = 'SendEmailAsync'
}
